import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-53186910"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-view-data-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        (_ctx.filterRoute === 'mat')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_v_col, { cols: _ctx.leftCol }, {
                default: _withCtx(() => [
                  _createTextVNode("Название:")
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, { cols: _ctx.rightCol }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.currentData.brand), 1)
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, { cols: _ctx.leftCol }, {
                default: _withCtx(() => [
                  _createTextVNode("Модель: ")
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, { cols: _ctx.rightCol }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.currentData.carModel), 1)
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, { cols: _ctx.leftCol }, {
                default: _withCtx(() => [
                  _createTextVNode("Года выпуска:")
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, { cols: _ctx.rightCol }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.currentData.carYear), 1)
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, { cols: _ctx.leftCol }, {
                default: _withCtx(() => [
                  _createTextVNode("Цена со скидкой, б.р.")
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, { cols: _ctx.rightCol }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.currentData.salePrice), 1)
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, { cols: _ctx.leftCol }, {
                default: _withCtx(() => [
                  _createTextVNode("Цвет:")
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, { cols: _ctx.rightCol }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.currentData.color), 1)
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, { cols: _ctx.leftCol }, {
                default: _withCtx(() => [
                  _createTextVNode("Тип:")
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, { cols: _ctx.rightCol }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.currentData.matType), 1)
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, { cols: _ctx.leftCol }, {
                default: _withCtx(() => [
                  _createTextVNode("Комплект:")
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, { cols: _ctx.rightCol }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.currentData.located), 1)
                ]),
                _: 1
              }, 8, ["cols"])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createTextVNode("Общая цена:")
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "8" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(100))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}